import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useOrderBundleItem from '@hooks/useOrderBundleItem'
import useOrderBundleItems from '@hooks/useOrderBundleItems'

import OrderBundleProductsTable from './OrderBundleProductsTable'

const OrderBundleItemActions = (props: { orderBundleId: number }) => {
  const { orderBundleId } = props

  const useOrderBundleItemsPayload = useOrderBundleItems({
    filters: {
      order_bundle_id: orderBundleId,
    },
    performHttpRequests: !!orderBundleId,
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredOrderBundleItems,
    filteredOrderBundleItemsCount,
    hasFilteredOrderBundleItems,
    loading,
  } = useOrderBundleItemsPayload

  const { provider } = useCurrentUser()

  const {
    callbacks: { createOrEditOrderBundleItem },
  } = useOrderBundleItem({ order_bundle_id: orderBundleId, provider_id: provider?.id })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Products"
    >
      {!loading && !hasFilteredOrderBundleItems && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>No Products present.</DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or add a Product.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredOrderBundleItems
       && <OrderBundleProductsTable filteredOrderBundleItems={filteredOrderBundleItems} />}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredOrderBundleItemsCount}
        // @ts-expect-error TS2322
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditOrderBundleItem()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Product
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default OrderBundleItemActions
